<template>
  <span
    :class="[
      'badge',
      variant && `text-bg-${variant}`,
      pill && 'rounded-pill'
    ]"
  >
    <slot />
  </span>
</template>

<script setup>
import { THEME_VARIANTS } from '@shared/constants/bootstrap'

defineProps({
  variant: {
    type: String,
    required: false,
    default: 'secondary',
    validator: (val) => THEME_VARIANTS.includes(val),
  },
  pill: {
    type: Boolean,
    required: false,
  },
})
</script>
